import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LoaderProvider } from "./utils/LoaderContext";
import GlobalLoader from "./utils/GlobalLoader";
import { ToastifyProvider } from "./utils/ToastifyProvider";
import { SocketProvider } from "./context/SocketContext";
import { BrowserRouter } from "react-router-dom";
import { CallProvider } from "./context/temp";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <LoaderProvider>
          <SocketProvider>
            <CallProvider>
              <GlobalLoader />
              <ToastifyProvider />
              <App />
            </CallProvider>
          </SocketProvider>
        </LoaderProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
